export const footer = {
  uk: {
    columns: [
      {
        heading: "КОНТАКТИ",
        items: [
          { type: "text", text: "WhatsApp: 07706 204681 (лише повідомлення)" },
          { type: "link", href: "mailto:vikhulei@gmail.com", text: "info@teachlearn.co.uk" },
        ],
      },
      {
        heading: "КОРИСНІ ПОСИЛАННЯ",
        items: [
          { type: "extLink", href: "https://www.esolcourses.com/", text: "ESOL courses" },
          { type: "extLink", href: "https://www.bbc.co.uk/learningenglish", text: "BBC Learning English" },
          { type: "extLink", href: "https://learnenglish.britishcouncil.org/", text: "British Council – LearnEnglish" },
        ],
      },
      {
        heading: "ПРО КУРС",
        items: [
          { type: "route", to: "/about", text: "Опис курсу" },
          { type: "action", action: "contact", text: "Написати повідомлення" },
          { type: "text", text: "© Віктор Гулей. Усі права захищені." },
        ],
      },
      {
        heading: "СОЦІАЛЬНІ МЕРЕЖІ",
        items: [
          { type: "social", name: "instagram" },
          { type: "social", name: "x" },
          { type: "social", name: "facebook" },
          { type: "wipText", text: "work in progress" },
          { type: "action", text: "Google Meet" },
        ],
      },
    ],
  },

  en: {
    columns: [
      {
        heading: "OUR CONTACTS",
        items: [
          { type: "text", text: "WhatsApp: 07706 204681 (messages only)" },
          { type: "link", href: "mailto:vikhulei@gmail.com", text: "info@teachlearn.co.uk" },
        ],
      },
      {
        heading: "USEFUL LINKS",
        items: [
          { type: "extLink", href: "https://www.esolcourses.com/", text: "ESOL courses" },
          { type: "extLink", href: "https://www.bbc.co.uk/learningenglish", text: "BBC Learning English" },
          { type: "extLink", href: "https://learnenglish.britishcouncil.org/", text: "British Council – LearnEnglish" },
        ],
      },
      {
        heading: "ABOUT US",
        items: [
          { type: "route", to: "/about", text: "Course Description" },
          { type: "action", action: "contact", text: "Send a Message" },
          { type: "text", text: "© 2025 Viktor Hulei. All rights reserved." },
        ],
      },
      {
        heading: "SOCIAL MEDIA",
        items: [
          { type: "social", name: "instagram" },
          { type: "social", name: "x" },
          { type: "social", name: "facebook" },
          { type: "wipText", text: "work in progress" },
          { type: "action", text: "Google Meet" },
        ],
      },
    ],
  },
};
